import Vue from 'vue'
import Vuetify, { UserVuetifyPreset } from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export function createVuetify(options: Partial<UserVuetifyPreset> | undefined = undefined) {
  const defaults = {
    icons: {
      iconfont: 'fa'
    },
    theme: {
      options: {
        customProperties: true
      }
    }
  }
  return new Vuetify(Object.assign(defaults, options || {}))
}
